import RouteConstants from '@/features/router/RouteConstants';
import { BreadcrumbItem } from '@/lib/Breadcrumbs';
import { FC } from 'react';
import { useSelector } from 'react-redux';
import { RootState, useAppDispatch } from '../../../../reducers';
import { useUnifiedProfilesValues } from '../../context';
import { reset } from '../../unifiedProfilesSlice';
import { UnifiedProfileSearch } from './UnifiedProfileSearch';
import { UnifiedProfilesList } from './UnifiedProfilesList';

const breadcrumbs: BreadcrumbItem[] = [
  {
    label: 'unifiedProfile:unifiedProfilesBreadcrumbs',
    path: RouteConstants.unifiedProfiles,
  },
];

export const UnifiedProfilesListTab: FC = () => {
  const dispatch = useAppDispatch();

  const { searchText } = useUnifiedProfilesValues();
  const uiState = useSelector((state: RootState) => state.unifiedProfiles.ui);
  if (!uiState.search) {
    dispatch(reset());
  }

  return searchText ? <UnifiedProfilesList breadcrumbs={breadcrumbs} /> : <UnifiedProfileSearch breadcrumbs={breadcrumbs} />;
};
